<div data-spy="scroll" data-target=".fixed-top">
  <div>
    <!-- Navigation -->
    <app-public-navbar></app-public-navbar>
    <!-- end of navigation -->
  </div>


</div>

<section class="privacy-hero">
  <div class="privacy-container">
    <h1>Cookie <span style="color: rgba(86, 173, 255, 1);">Policy</span></h1>
    <!-- <p class="subtext">
      Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.
    </p> -->

    <div class="privacy-layout">
      <!-- Left Side Menu -->
      <!-- <aside class="privacy-menu">
        <ul>
          <li><a href="#policy1">Policy 01</a></li>
          <li><a href="#policy2">Policy 02</a></li>
          <li><a href="#policy3">Policy 03</a></li>
          <li><a href="#policy4">Policy 04</a></li>
          <li><a href="#policy5">Policy 05</a></li>
        </ul>
      </aside> -->

      <!-- Main Content -->
      <div class="privacy-content">
        <p>By continuing to use Connekktxchange.com, our mobile applications, and our services (collectively, the
          “Services”), you acknowledge and agree to our use of cookies and similar tracking technologies as described in
          this Policy.</p>
            <div class="date-container">
              <h2> Effective Date:</h2>
              <p>July 2025</p>
            </div>
             <div class="date-container">
              <h2> Last Updated:</h2>
              <p>January 2026</p>
            </div>
        <section id="policy1">
          <h2>Use of Tracking Technologies</h2>
          <p>
            We, along with our third-party partners and analytics service providers, use standard tracking
            technologies—including cookies, web beacons, and tags—to provide a high-quality user experience. We use
            these tools to: </p>

          <ul>
            <li> Recognize & Remember: Identify your device and remember your preferences, such as login status,
              language
              settings, and display options.
            </li>
            <li>
              Analyze Performance: Understand how visitors navigate Connekktxchange.com, which helps us improve our
              website structure and content.
            </li>
            <li>
              Personalization: Tailor our Services to your specific interests and behavior to greet you by name or show
              relevant content.
            </li>
            <li>
              Security & Authentication: Prevent fraudulent activity, authenticate users during login, and ensure secure
              access to restricted areas of the platform.
            </li>
          </ul>
        </section>

        <section id="policy2">
          <h2>Types of Cookies We Use</h2>
          <!-- <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
            bibendum consectetur tortor at fermentum. Ut vitae augue nec velit
            porttitor tempor.
          </p> -->
          <h6>Strictly Necessary Cookies: </h6>
          <p>Essential for the operation of the website. These include cookies that enable you to log into secure areas
            or fill out forms.</p>
          <br>
          <h6>nalytical/Performance Cookies: </h6>
          <p>These allow us to recognize and count the number of visitors and see how they move around the site. We use
            this to improve site functionality (e.g., ensuring users find what they are looking for easily).</p>
          <br>
          <h6>Functionality Cookies </h6>
          <p>Used to recognize you when you return to our website. This enables us to personalize our content for you
            and remember your preferences (like your choice of language or region).</p>
          <br>
          <h6>Targeting/Advertising Cookies: </h6>
          <p>hese record your visit to our website, the pages you have visited, and the links you have followed. We use
            this information to make our website and the advertising displayed on it more relevant to your interests.
          </p>
        </section>

        <section id="policy3">
          <h2>Third-Party Cookies</h2>
          <p>
            We may use third-party services such as Google Analytics to report usage statistics and deliver relevant
            advertisements. These third parties (including ad networks and providers of external services like web
            traffic analysis) may also use cookies over which we have no direct control.
          </p>
        </section>

        <section id="policy4">
          <h2>Your Choices & Controls</h2>
          <p>
            You have the right to manage how cookies are used on your device:
          </p>
          <br>
          <h6>Browser Settings: </h6>
          <p> You can block cookies by activating the setting on your browser that allows you to refuse all or some
            cookies.</p>
          <br>
          <h6>Mobile Settings: </h6>
          <p> Adjust advertising preferences or reset advertising IDs in your device’s privacy settings (iOS or
            Android).</p>
          <br>
          <h6>Consequences of Opting Out: </h6>
          <p> If you use your browser settings to block all cookies (including essential cookies), you may not be able
            to access all or parts of Connekktxchange.com.</p>
        </section>

        <section id="policy5">
          <h2>"Do Not Track" Signals</h2>
          <p>At this time, our Services do not respond to "Do Not Track" (DNT) browser signals, as a uniform industry
            standard for recognizing these signals has not yet been established.

          </p>
        </section>
        <section id="policy5">
          <h2>Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy periodically to reflect changes in technology or legal requirements. We
            encourage you to review this page regularly for the latest information on our privacy practices.

          </p>
        </section>
        <section id="policy5">
          <h2>Contact Us
          </h2>
          <p>

            If you have any questions regarding our use of cookies, please contact our Data Protection team at:

            Email: support@connekktxchange.com

            Website: Connekktxchange.com


          </p>
        </section>
      </div>
    </div>
  </div>
</section>

<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="footer-col first">
          <h6>About Connekkt Xchange</h6>
          <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers,
            studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content
            across global markets.
          </p>
        </div> <!-- end of footer-col -->
        <div class="footer-col second">
          <h6>Useful Links</h6>
          <ul class="list-unstyled li-space-lg p-small">
            <li><a href="/terms&conditions">Terms & Conditions</a><br /> <a href="/privacy-policy">Privacy
                Policy</a><br> <a routerLink="/faqs">FAQs</a><br><a routerLink="/contact-us">Contact Us</a> </li>
            <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                      href="#">Illustrations</a></li>
                              <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                      href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                      class="page-scroll" href="#details">Details</a></li> -->
          </ul>
        </div> <!-- end of footer-col -->
        <div class="footer-col third">
          <span class="fa-stack">
            <a href="#your-link">
              <img class="footer-img" src="assets/newImages/twitter.png" alt="">

              <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-facebook-f fa-stack-1x"></i> -->
            </a>
          </span>
          <span class="fa-stack">
            <a href="#your-link">
              <img class="footer-img" src="assets/newImages/facebook.png" alt="">

              <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-twitter fa-stack-1x"></i> -->
            </a>
          </span>
          <span class="fa-stack">
            <a href="#your-link">
              <img class="footer-img" src="assets/newImages/instagram.png" alt="">

              <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
            </a>
          </span>
          <span class="fa-stack">
            <a href="#your-link">
              <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

              <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-instagram fa-stack-1x"></i> -->
            </a>
          </span>
          <p class="p-small">We would love to hear from you <a
              href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
            <!-- <br/><a
                                      href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p> -->

        </div> <!-- end of footer-col -->
      </div> <!-- end of col -->
    </div> <!-- end of row -->

    <!-- Copyright -->
    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
          </div> <!-- end of col -->
        </div> <!-- enf of row -->
      </div> <!-- end of container -->
    </div> <!-- end of copyright -->

  </div> <!-- end of container -->
</div>